<template>
	<div class="nav-cart-line">
		<NavCartThumb :uid="line.thumbUid" :process="line.process" :quantity="line.quantity" :free="line.free" @zoom="line.hasImage && emit('action', { type: 'zoom', key: line.key })" />
		<div class="nav-cart-line__content">
			<button type="button" class="nav-cart-line__name" @click="emit('action', { type: 'detail', key: line.key })">{{ line.name }}</button>
			<span v-if="showReference && line.reference" class="nav-cart-line__reference">{{ line.reference }}</span>
			<div class="nav-cart-line__controls">
				<v-btn icon variant="tonal" size="x-small" @click="emit('action', { type: 'decrease', key: line.key })">
					<v-icon>remove</v-icon>
				</v-btn>
				<v-btn icon variant="tonal" size="x-small" @click="emit('action', { type: 'increase', key: line.key })">
					<v-icon>add</v-icon>
				</v-btn>
			</div>
		</div>
		<v-btn icon variant="text" size="small" @click="emit('action', { type: 'remove', key: line.key })">
			<v-icon>delete</v-icon>
		</v-btn>
	</div>
</template>

<script setup>
import NavCartThumb from './NavCartThumb.vue';

defineProps({
	line: { type: Object, required: true },
	showReference: { type: Boolean, default: false },
});
const emit = defineEmits(['action']);
</script>
